import { useTranslation } from 'react-i18next';
import { CreditCard, Building2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';

interface PaymentMethod {
  id: string;
  type: 'card' | 'bank_account';
  last4: string;
  brand?: string;
  expiryMonth?: number;
  expiryYear?: number;
  isDefault: boolean;
}

interface PaymentMethodDisplayProps {
  paymentMethods: PaymentMethod[];
  onManage: () => void;
}

export function PaymentMethodDisplay({ paymentMethods, onManage }: PaymentMethodDisplayProps) {
  const { t } = useTranslation();

  const defaultMethod = paymentMethods.find((pm) => pm.isDefault) || paymentMethods[0];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>{t('billing.paymentMethod')}</CardTitle>
        <Button variant="outline" size="sm" onClick={onManage}>
          {paymentMethods.length > 0
            ? t('billing.updatePaymentMethod')
            : t('billing.addPaymentMethod')}
        </Button>
      </CardHeader>
      <CardContent>
        {!defaultMethod ? (
          <p className="text-muted-foreground">{t('billing.noPaymentMethod')}</p>
        ) : (
          <div className="flex items-center gap-4 p-3 rounded-lg border">
            {defaultMethod.type === 'card' ? (
              <CreditCard className="h-8 w-8 text-muted-foreground" />
            ) : (
              <Building2 className="h-8 w-8 text-muted-foreground" />
            )}
            <div>
              <p className="font-medium">
                {defaultMethod.type === 'card'
                  ? `${defaultMethod.brand?.toUpperCase() || 'Card'} •••• ${defaultMethod.last4}`
                  : `Bank •••• ${defaultMethod.last4}`}
              </p>
              {defaultMethod.type === 'card' &&
                defaultMethod.expiryMonth &&
                defaultMethod.expiryYear && (
                  <p className="text-sm text-muted-foreground">
                    {t('billing.expires')} {defaultMethod.expiryMonth}/{defaultMethod.expiryYear}
                  </p>
                )}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
